import request from '@/utils/request'
import qs from 'qs'
import { encryptionObj } from '@/utils/crypto'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}

// 钉钉登录
export function getUserWithCorpId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/dingtalk/login/get/user/by/corpid',
		method: 'post',
		data: obj
	})
}
// 解密
export function getPass (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/mercmerchant/mobile/password/decrypt/${data}`,
		method: 'post',
		data: obj
	})
}

// 获取logo
export function getLogo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/metadata/queryLogoConfig',
		method: 'get',
		params: obj
	})
}

export function setLogo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/metadata/logoConfig',
		method: 'post',
		data: obj
	})
}

export function login (data) {
	// let grant_type = "password";
	const dataObj = qs.stringify({
		content: JSON.stringify(encryptionObj(data, ['password']))
	})
	return request({
		url: '/oauth/web/token',
		method: 'post',
		headers: {
			// Authorization: "Basic dGVzdDp0ZXN0"
			'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			code: data.code
		},
		// params: {
		//   grant_type
		// },
		data: dataObj
	})
}

// 获取用户基本信息
export function getInfo (token) {
	const obj = JSON.parse(JSON.stringify(dataObj))

	return request({
		url: '/api/v1/mgrmenu/menus/user',
		method: 'get',
		params: obj
	})
}

export function logout (token) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	return request({
		url: '/oauth/logOut',
		method: 'delete',
		// headers: {
		//   Authorization: token
		// },
		data: obj
	})
}

// 根据旧密码修改密码
export function editpwd (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/change/password/by/old',
		method: 'post',
		data: obj,
		encryption: ['oldPassword', 'newPassword']
	})
}

export function changepassword (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	console.log(data)
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/change/password',
		method: 'put',
		data: obj,
		encryption: ['password']
	})
}

// 获取用户信息
export function getUser (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/detail/info',
		method: 'post',
		data: obj
	})
}
// 获取商户用户详细信息
export const getMerchantUserInfo = userId => {
	return request({
		url: `/api/v1/mgruser/info/${userId}`,
		method: 'get',
		params: { ...dataObj }
	})
}
// 查询所有配送员信息
export const getAllDelivery = data => {
	return request({
		url: '/api/v1/mgruser/all/delivery/list',
		method: 'get',
		params: { ...dataObj, content: data || undefined }
	})
}
// 根据人员姓名获取人员列表
export const getUserListByCustName = data => {
	return request({
		url: '/custInfo/queryCustName/byCustName',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

export function ssoLogin (data) {
	return request({
		url: `/oauth/web/single-sign-on?tenantId=${data.params.tenantId}`,
		method: 'post',
		headers: {
			// Authorization: "Basic dGVzdDp0ZXN0"
			'Content-Type': 'application/json',
			code: data.code,
			tenantId: data.tenantId
		},
		data: { ...dataObj, content: data || undefined }
	})
}
